import React from 'react'
import { Outlet } from 'react-router-dom'

export default function LoginLayout() {
    return (
        <div className="flex flex-col items-center min-h-screen p-10 bg-gray dark:bg-boxdark2 dark:text-bodydark">
            <div className="bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                <div className="flex flex-wrap items-center">
                    <div
                        className="hidden w-full xl:block xl:w-1/2 bg-cover bg-center"
                        style={{ backgroundImage: `url(/images/weallat-bg.png)` }}
                    >
                        <div className="px-10 text-right py-[9.7rem]">
                            <span className="inline-block invisible">
                                <img src="/images/weallat-logo.png" alt="error" width={70} height={70}/>
                            </span>
                           
                            <h2 className="text-2xl font-bold text-black invisible">Quoffee</h2>
                            <p className="2xl:px-20 invisible">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit suspendisse.
                            </p>
                        </div>
                    </div>

                    <div className="w-full max-w-xl border-stroke dark:border-strokedark xl:w-1/2 xl:border-l-2">
                        <div className="w-full p-5 sm:p-6 xl:p-10">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
